import PropTypes from "prop-types"
import { Route } from "react-router-dom"

import GenericNotFound from "app/generic-not-found"
import { jewlr_t, IS_JEWLR } from "helpers/application"
import { Routes } from "helpers/sentry"

import ChangeShippingAddress from "./change-shipping-address"
import CompletedRequest from "./completed-request"
import Edit from "./edit"
import GiftPackaging from "./gift-packaging"
import OrderRouteWrapper from "./order-route-wrapper"
import PurchaseWarranty from "./purchase-warranty"
import Repair from "./repair"
import Resize from "./resizing"
import Return from "./return"
import OrderStatus from "./status"
import UpgradeShipping from "./upgrade-shipping"

const Order = ({ orderUpdateData }) => {
  const orderRouteData = [
    {
      component: Edit,
      contain: true,
      description:
        "Use the Jewlr Order Change Request form to update or modify your order details. Submit changes quickly before your order enters production.",
      path: "/change",
      rmaType: "change",
      title: "Jewlr Order Change Request | Modify or Update Your Order",
      validatePath: "/secure/api/v10/order/validate_order_change",
    },
    {
      component: Repair,
      contain: true,
      path: "/repair",
      rmaType: "repair",
      title: "Request Repair Form",
      validatePath: "/secure/api/v10/order/order_info_for_rma",
    },
    {
      component: Resize,
      contain: true,
      path: "/resizing",
      rmaType: "resize",
      title: "Request Resizing Form",
      validatePath: "/secure/api/v10/order/order_info_for_rma",
    },
    {
      component: Return,
      contain: true,
      path: "/return",
      rmaType: "return",
      title: "Request Return Form",
      validatePath: "/secure/api/v10/order/order_info_for_rma",
    },
    {
      component: CompletedRequest,
      contain: true,
      path: "/completed_repair",
      rmaType: "repair",
      title: "Repair Request Submitted",
    },
    {
      component: CompletedRequest,
      contain: true,
      path: "/completed_return",
      rmaType: "return",
      title: "Return Request Submitted",
    },
    {
      component: UpgradeShipping,
      contain: true,
      description: `Use the Jewlr Upgrade ${jewlr_t("terms.Shipping")} form to change your delivery method. Submit a request to update ${jewlr_t("terms.shipping")} details before your order is dispatched.`,
      path: "/upgrade-shipping",
      title: `Jewlr Upgrade ${jewlr_t("terms.Shipping")} | Change or Update Delivery Method`,
      validatePath: "/secure/api/v10/order/order_shipping_methods",
    },
    {
      component: ChangeShippingAddress,
      contain: true,
      path: "/change-shipping-address",
      title: `Change Your ${jewlr_t("terms.Shipping")} Address`,
      validatePath: "/secure/api/v10/order/prepare_address_change",
    },
    {
      component: GiftPackaging,
      contain: true,
      description: `Add premium gift packaging to your Jewlr order with bundled gift wrap and card options, including limited-time seasonal designs, to make your ${jewlr_t("terms.jewelry")} extra special.`,
      path: "/gift-packaging",
      title: `Jewlr Gift Packaging | Add Gift Packaging to Your ${jewlr_t("terms.Jewelry")} Order`,
      validatePath: "/api/v10/orders/gift_packaging",
    },
  ]

  if (sl.config.enable_extend_warranty) {
    const warrantyRouteParams = {
      component: PurchaseWarranty,
      contain: false,
      path: "/purchase-warranty",
      title: "Add Protection Coverage",
      validatePath: "/secure/api/v10/order/warranty_offers",
    }
    orderRouteData.push(warrantyRouteParams)
  }

  return (
    <Routes>
      {IS_JEWLR() &&
        orderRouteData.map(
          (
            {
              component: Component,
              contain,
              description,
              path,
              rmaType,
              title,
              validatePath,
            },
            i
          ) => {
            return (
              <Route
                element={
                  <OrderRouteWrapper
                    contain={contain}
                    description={description}
                    title={title}
                  >
                    <Component
                      orderUpdateData={orderUpdateData}
                      rmaType={rmaType}
                      validatePath={validatePath}
                    />
                  </OrderRouteWrapper>
                }
                key={`order_route${i}`}
                path={path}
              />
            )
          }
        )}
      <Route element={<OrderStatus />} path="/:orderToken" />
      <Route element={<GenericNotFound />} path="*" />
    </Routes>
  )
}

Order.propTypes = {
  orderUpdateData: PropTypes.object,
}

export default Order
